import React, { useEffect, useState } from "react";

import Header from "../home/header";
import Loading from "../home/Loading";
import { useLocation, useNavigate } from "react-router";
import UTILS from "../../utils/commons";
import { ApiClient } from "../../utils/api-client";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { AxiosError } from 'axios'


const ExpenseForm = props => {
    var navigate = useNavigate();
    var location = useLocation();
    const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
    const apiClient = new ApiClient( loginState ? loginState.accessToken : null );

    const [ isLoading, setIsLoading ] = useState( false );
    const [ feedback, setFeedback ] = useState( "" );
    const [ trans, setTrans ] = useState( 0 );
    const [ transactions, setTransactions ] = useState( [] );
    const [ inventory, setInventory ] = useState( [] );
    const [ customers, setCustomers ] = useState( [] );
    const [ products, setProducts ] = useState( [] );
    const [ payments, setPayments ] = useState( [] );
    const [ suppliers, setSuppliers ] = useState( [] );
    const paymentTypes = [
        { id: 2, text: "Operational Expense" },
    ]
    
    const loadData = async () => {
        try {
            const [ custRes, invRes ] = await Promise.all( [
                apiClient.get( loginState.role === UTILS.ADMIN ? "customers" : `customers/profile/${loginState.profile.id}` ),
                apiClient.get( loginState.role === UTILS.ADMIN ? "inventory" : `issues/profile/${loginState.profile.id}` ),
            ] );
            if ( custRes.status === 200 && custRes.data ) {
                setCustomers( custRes.data );
            }
            if ( invRes.status === 200 && invRes.data ) {
                setInventory( invRes.data );
            }
        }
        catch ( e ) {
            console.log( "Error loading data: ", e );
        }
    }
    const handleFileChange = ( e ) => {
        const file = e.target.files[ 0 ];
        if ( file ) {
            const reader = new FileReader()
            reader.onload = () => {
                const url = URL.createObjectURL( file );
                formik.setFieldValue( "file", reader.result );
            };
            reader.readAsDataURL( file );
        }
        else setFeedback( "Please select a file" );
    }

    // Helper to format number with commas
    const formatNumberWithCommas = ( value ) => {
        if ( value === null || value === undefined ) return '';
        const parts = value.toString().split( "." );
        parts[ 0 ] = parts[ 0 ].replace( /\B(?=(\d{3})+(?!\d))/g, "," );
        return parts.join( "." );
    };

    // Handler for amount input with formatting
    const handleAmountChange = ( e ) => {
        let input = e.target.value.replace( /,/g, '' ); // Remove commas
        // Only allow numbers and optional decimal
        if ( !/^\d*(\.\d*)?$/.test( input ) ) return;
        // Update Formik with raw value
        formik.setFieldValue( 'amount', input );
    };
    useEffect( () => {
        loadData();
    }, [] )
    const formik = useFormik( {
        initialValues: {
            type: paymentTypes[ 0 ].id,
            paymentDate: '',
            supplierId: null,
            invoiceNumber: '',
            amount: '',
            paidTo: '',
            reason: '',
            file: null,
        },
        validationSchema: Yup.object( {
            type: Yup.number().required(),
            paymentDate: Yup.string().required( 'Date is required' ),
            amount: Yup.string().required( 'Amount is required' ),
            reason: Yup.string().required( 'Reason is required' ),
            file: Yup.mixed().required( 'Supporting document is required' ),

        } ),
        onSubmit: async ( values ) => {
            setIsLoading( true );
            const payment = {
                ...values,
                profileId: loginState.role == UTILS.SALES || loginState.role == UTILS.FINANCE || loginState.role == UTILS.STAFF ? loginState.profile.id : null,
            }
            savePayment( payment );
        },
    } );
    //save transaction
    const savePayment = async ( payment ) => {
        console.log( "🚀 ~ savePayment ~ payment:", payment )
        try {
            const req = await apiClient.post( "/payments", payment );

            setIsLoading( false );
            if ( req.status === 201 ) {
                navigate( "/expenses", { replace: true } );
            }
            else {
                setFeedback( 'Oops! Something went wrong' );
            }
        }
        catch ( e ) {
            console.log( "Error saving payment: ", e );
            setFeedback( 'Oops! Something went wrong' );
            setIsLoading( false );
            if ( e instanceof AxiosError && e.response && e.response.status === 401 ) {
                UTILS.signout();
                navigate( `/signin`, { replace: true, state: { target: '/payments/new' } } );
                return;
            }
        }

    }



    useEffect( () => {

    }, [] )


    return (
        <>
            <Header auth={loginState} />
            <section className="flex justify-start items-start">
                <div className="container mx-auto md:mt-8">
                    {feedback.length > 0 ? <div className="w-10/12 md:w-8/12 mx-auto mb-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-red-700 text-sm" id="form-feedback">{Object.keys( formik.errors ).join( ", " )}</div> : null}
                    <div className="md:w-10/12 md:mx-auto rounded-xl border border-gray-200 bg-white shadow-md pt-10 px-3 md:px-6">
                        <div className="text-center mx-auto w-full">
                            <p className="text-sm uppercase tracking-wide text-gray-500 text-center">Expense Setup</p>
                            <p className="text-center text-2xl font-semibold text-gray-800 my-3">Register an Expense</p>
                            <form id="payment_form" className=" text-start w-10/12 md:w-9/12 mx-auto mb-16" onSubmit={formik.handleSubmit}>
                                <div className="flex flex-col justify-evenly w-full mx-auto px-4 ">
                                    <div className="form-group my-2 w-10/12 md:w-8/12 lg:w-8/12 mx-auto">
                                        <label htmlFor="type">Payment Type</label>
                                        <select className="form-control" id="type" name="type" value={formik.values.type} onChange={formik.handleChange}>
                                            {paymentTypes.map( pt => {
                                                return <option key={pt.id} value={pt.id}>{pt.text}</option>
                                            } )}
                                        </select>
                                        {formik.touched.type && formik.errors.type ? (
                                            <div className="text-danger small">{formik.errors.type}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group my-2 w-10/12 md:w-8/12 lg:w-8/12 mx-auto">
                                        <label htmlFor="paymentDate">Date of Payment <em className="text-danger">*</em></label>
                                        <input type="date" className="form-control" id="paymentDate" name="paymentDate" value={formik.values.paymentDate} onChange={formik.handleChange} onBlur={formik.handleBlur} />
                                        {formik.touched.paymentDate && formik.errors.paymentDate ? (
                                            <div className="text-danger small">{formik.errors.paymentDate}</div>
                                        ) : null}
                                    </div>
                                </div>
                              
                                <div className="flex flex-col justify-evenly w-full mx-auto px-4">
                                    <div className="form-group my-2 w-10/12 md:w-8/12 lg:w-8/12 mx-auto">
                                        <label htmlFor="amount">Amount TZS <em className="text-danger">*</em></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="amount"
                                            name="amount"
                                            value={formatNumberWithCommas( formik.values.amount )}
                                            onChange={handleAmountChange}
                                            onBlur={formik.handleBlur}
                                            inputMode="decimal"
                                            autoComplete="off"
                                        />
                                        {formik.touched.amount && formik.errors.amount ? (
                                            <div className="text-danger small">{formik.errors.amount}</div>
                                        ) : null}
                                    </div>
                                    
                                        <div className="form-group my-2 w-10/12 md:w-8/12 lg:w-8/12 mx-auto">
                                            <label htmlFor="paidTo">Paid To <em className="text-danger">*</em></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="paidTo"
                                                name="paidTo"
                                                value={formik.values.paidTo}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                autoComplete="off"
                                            />
                                            {formik.touched.paidTo && formik.errors.paidTo ? (
                                                <div className="text-danger small">{formik.errors.paidTo}</div>
                                            ) : null}
                                        </div>
                                        <div className="form-group my-2 w-10/12 md:w-8/12 lg:w-8/12 mx-auto">
                                            <label htmlFor="reason">Being payment for <em className="text-danger">*</em></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="reason"
                                                name="reason"
                                                value={formik.values.reason}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                autoComplete="off"
                                            />
                                            {formik.touched.reason && formik.errors.reason ? (
                                                <div className="text-danger small">{formik.errors.reason}</div>
                                            ) : null}
                                    </div>
                                    
                                    <div className="form-group my-2 w-10/12 md:w-8/12 lg:w-8/12 mx-auto">
                                        <label htmlFor="file">Supporting Document <em className="text-danger">*</em></label>
                                        <input type="file" className="form-control" id="file" name="file" onChange={handleFileChange} />
                                        {formik.touched.file && formik.errors.file ? (
                                            <div className="text-danger small">{formik.errors.file}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="flex justify-between w-full mx-auto px-16">
                                    {/* Hide submit if amount is 0/empty or no customer (when type 0) */}
                                    <div className="form-group my-2 w-10/12 md:w-4/12 lg:w-3/12 mx-auto">
                                        {( () => {
                                            const amountNum = Number( ( formik.values.amount || '' ).replace( /,/g, '' ) );
                                            const isAmountInvalid = !amountNum || amountNum === 0;
                                           
                                            if ( isAmountInvalid ) return null;
                                            return isLoading ? <Loading /> : (
                                                <input type="submit" className="form-control bg-success" id="btnSubmit" name="btnSubmit" value="SUBMIT" />
                                            );
                                        } )()}
                                    </div>
                                    <div className="form-group my-2 w-10/12 md:w-4/12 lg:w-3/12 mx-auto">
                                        <input onClick={() => { navigate( -1, { replace: true } ) }}
                                            type="button"
                                            className="form-control"
                                            value="Cancel"
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )

}
export default ExpenseForm;
